import React, { memo, useContext, useEffect, useReducer } from 'react';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import './css/HomePage1ArticlesEvents1.css';
import { context } from '../../../../../../globalState/GlobalState';
import { fetchLimitedArticlesAPI } from '../../../../../apiCalls/ArticleAPICalls';
import { fetchLimitedUpcomingEventsAPI } from '../../../../../apiCalls/EventAPICalls';
import EventThumbnail3 from '../../../../../uiElements/eventAndPracticeThumbnails/eventThumbnail3/EventThumbnail3';
import { isValidObject } from '../../../../../../catalog/Validity';
import Spinner2 from '../../../../../uiElements/spinners/spinner2/Spinner2';
import ArticleThumbnail7 from '../../../../../uiElements/articleThumbnails/articleThumbnail7/ArticleThumbnail7';

const initialState = {
    type: 'articles',
    articles: [],
    events: [],
    loadingSpinner: true,
};

function reducer(state, action) {
    let type = 'articles';
    if (isValidObject(action.events) && state.articles.length === 0 && action.events.length > 0) {
        type = 'events';
    }
    switch (action.type) {
        case 'setType':
            return { ...state, type: action.buttonType };
        case 'fetchArticles':
            return { ...state, articles: action.articles };
        case 'fetchUpcomingEvents':
            return { ...state, events: action.events, type };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}

const HomePage1ArticlesEvents1 = (props) => {
    const { whiteTitle } = props;
    const [state, setState] = useReducer(reducer, initialState);
    const history = useHistory();
    const { globalState } = useContext(context);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        async function fetchArticles() {
            setState({ type: 'setLoadingSpinner', loadingSpinner: true });
            await fetchLimitedArticlesAPI(globalState.accountId, 3, setState, enqueueSnackbar);
            setState({ type: 'setLoadingSpinner', loadingSpinner: false });
            await fetchLimitedUpcomingEventsAPI(globalState.accountId, 2, setState, enqueueSnackbar);
            if (state.articles.length === 0 && state.events.length > 0) {
                setState({ type: 'setType', buttonType: 'events' });
            }
        }
        fetchArticles();
    }, []);

    const showArticles = () => {
        if (state.articles.length === 0 && state.events.length > 0) {
            return false;
        }
        return true;
    };

    const showEvents = () => {
        return state.events.length > 0;
    };

    return (
        <div className="homepage1-articles1-events1-container full-width">
            <div className="full-width m-b-10px">
                {showArticles() ? (
                    <button
                        type="button"
                        className={`alegreya-font-family font-weight-500 m-t-0 m-l-0 m-r-10px m-b-0 text-left-align font-size-m text-uppercase text-white text-no-underline ${whiteTitle ? 'text-white' : 'text-black'} ${state.type === 'articles' ? 'homepage1-articles1-events1-button-active' : 'homepage1-articles1-events1-button-not-active'}`}
                        onClick={() => {
                            if (state.type === 'articles') {
                                history.push('/articles');
                            } else {
                                setState({ type: 'setType', buttonType: 'articles' });
                            }
                        }}
                    >
                        Articles
                    </button>
                ) : null}
                {showEvents() ? (
                    <button
                        type="button"
                        className={`alegreya-font-family font-weight-500 m-t-0 m-l-10px m-r-0 m-b-0 text-center-align font-size-m text-uppercase text-white text-no-underline ${whiteTitle ? 'text-white' : 'text-black'} ${state.type === 'events' ? 'homepage1-articles1-events1-button-active' : 'homepage1-articles1-events1-button-not-active'}`}
                        onClick={() => {
                            if (state.type === 'events') {
                                history.push('/events');
                            } else {
                                setState({ type: 'setType', buttonType: 'events' });
                            }
                        }}
                    >
                        Events
                    </button>
                ) : null}
            </div>
            {state.type === 'articles' ? (
                <>
                    <div className="homepage1-articles homepage1-articles-desktop">
                        {state.loadingSpinner ? (<Spinner2 color={globalState.websiteStyles.colors.primaryColor} marginTop={140} size={50} />) : (
                            <>
                                {state.articles.length > 0 ? (
                                    <>
                                        {state.articles.slice(0, 3).map((article) => {
                                            return (
                                                <div key={article.id} className="homepage1-article-container">
                                                    <ArticleThumbnail7 article={article} />
                                                </div>
                                            );
                                        })}
                                    </>
                                ) : <p className={`alegreya-font-family font-weight-500 font-size-3xl full-width text-center-align m-t-120px text-uppercase ${whiteTitle ? 'text-white' : 'text-black'}`}>No Articles Available</p>}
                            </>
                        )}
                    </div>
                    <div className="homepage1-articles homepage1-articles-mobile">
                        {state.loadingSpinner ? (<Spinner2 color={globalState.websiteStyles.colors.primaryColor} marginTop={130} size={50} />) : (
                            <>
                                {state.articles.length > 0 ? (
                                    <>
                                        {state.articles.slice(0, 2).map((article) => {
                                            return (
                                                <div key={article.id} className="homepage1-article-container mobile">
                                                    <ArticleThumbnail7 article={article} />
                                                </div>
                                            );
                                        })}
                                    </>
                                ) : <p className={`alegreya-font-family font-weight-500 font-size-3xl full-width text-center-align m-t-120px text-uppercase ${whiteTitle ? 'text-white' : 'text-black'}`}>No Articles Available</p>}
                            </>
                        )}
                    </div>
                </>
            ) : (
                <>
                    <div className="homepage1-events">
                        {state.loadingSpinner ? (<Spinner2 color={globalState.websiteStyles.colors.primaryColor} marginTop={130} size={50} />) : (
                            <>
                                {state.events.length > 0 ? (
                                    <>
                                        {state.events.slice(0, 2).map((event) => {
                                            return (
                                                <div key={event.id} className="homepage1-event-container full-width">
                                                    <EventThumbnail3 event={event} />
                                                </div>
                                            );
                                        })}
                                    </>
                                ) : <p className={`alegreya-font-family font-weight-500 font-size-3xl full-width text-center-align m-t-120px text-uppercase ${whiteTitle ? 'text-white' : 'text-black'}`}>No Events Available</p>}
                            </>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

HomePage1ArticlesEvents1.propTypes = {
    whiteTitle: PropTypes.bool,
};

HomePage1ArticlesEvents1.defaultProps = {
    whiteTitle: false,
};

export default memo(HomePage1ArticlesEvents1);
